export default "# 小休憩(2)\n\n## 進捗の度合いによって時間調整を行います\n";